<template>
  <div style="height: 60vh">
<!--    <el-tabs v-model="tabActive" type="card">-->
      <audio id="scanSuccessmp3" src="../../../public/audio/ScanSuccess.mp3"/>
      <audio id="scanFailuremp3" src="../../../public/audio/ScanFailure.mp3"/>
<!--      <el-tab-pane label="托盘绑定" name="first">-->
<!--        <div style="margin: 50px 0 10px 80px">-->
<!--          <div style="display: flex;flex-direction: row;align-items: center">-->
<!--            <span class="text" style="font-size: 18px">托盘条码： </span>-->
<!--            <span><input-->
<!--                ref="palletNo"-->
<!--                v-model="cb.palletNo"-->
<!--                style="width: 230px;border: 1px solid #e6e6e6;font-size: 12px;padding: 7px 15px"-->
<!--                placeholder="请输入"-->
<!--                @change="getPalletNo"></span>-->
<!--          </div>-->
<!--          <div style="margin: 20px 0;display: flex;flex-direction: row;align-items: center">-->
<!--            <span class="text" style="font-size: 18px">柜体条码： </span>-->
<!--            <span><input-->
<!--                ref="barcode"-->
<!--                v-model="cb.barcode"-->
<!--                style="width: 230px;border: 1px solid #e6e6e6;font-size: 12px;padding: 7px 15px"-->
<!--                placeholder="请输入"-->
<!--                @change="getBarcode"></span>-->
<!--          </div>-->
<!--          <div style="display: flex;flex-direction: row;">-->
<!--            <span class="text" style="font-size: 18px">站点代码： </span>-->
<!--            <el-select v-model="cb.stationCode" style="width: 260px" placeholder="请选择">-->
<!--              <el-option-->
<!--                  v-for="item in constants.stationCode.$options"-->
<!--                  :key="item.value"-->
<!--                  :label="item.label"-->
<!--                  :value="item.value"/>-->
<!--            </el-select>-->
<!--          </div>-->
<!--        </div>-->
<!--      </el-tab-pane>-->
<!--      <el-tab-pane label="控制柜扫描" name="first">-->
        <div style="margin: 50px 0 10px 80px">
          <div style="margin-bottom: 10px;display: flex;flex-direction: row;align-items: center">
            <span class="text" style="font-size: 18px">托盘条码： </span>
            <span><input
                ref="orders"
                v-model="cbs.palletNo"
                style="width: 230px;border: 1px solid #e6e6e6;font-size: 12px;padding: 7px 15px"
                placeholder="请输入"
                @change="getKZGManageScanCDS"></span>
          </div>
          <div style="margin-top: 25px;display: flex;flex-direction: row;">
            <span class="text" style="font-size: 18px">站点代码： </span>
            <el-select v-model="cbs.stationCode" style="width: 260px" placeholder="请选择">
              <el-option
                  v-for="item in constants.stationCode.$options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"/>
            </el-select>
          </div>
        </div>
<!--      </el-tab-pane>-->
<!--    </el-tabs>-->
  </div>
</template>

<script>
  import constants from "@/util/constants";
  export default {
    name: "",
    components: {},
    data() {
      return {
        constants,
        tabActive: "first",
        cb:{
          palletNo:"",
          barcode:"",
          stationCode:"ECCL1-1",
        },
        cbs:{
          palletNo:"",
          stationCode:"ECCL1-1",
        },
        filter: {
        },
      };
    },
    methods: {
      getPalletNo() {
        this.$refs["barcode"].focus();

      },
      getBarcode() {
        this.getKZGManageScanCD();
        this.$refs["palletNo"].focus();
      },
      audioPlay(val) {
        let musicMp3 = document.getElementById(val);
        musicMp3.play();
      },
      audioStop(val) {
        let musicMp3 = document.getElementById(val);
        musicMp3.pause();
      },
      getKZGManageScanCD() {
        console.log(this.cb.barcode);
        if(this.cb.barcode) {
          this.$http
            .post("basic", `sAPProductionOrders/cb/${this.cb.palletNo}/${this.cb.barcode}/${this.cb.stationCode}`)
            .then(() => {
              this.$message.success("扫描成功");
              this.cb.palletNo = "";
              this.cb.barcode = "";
              this.audioPlay("scanSuccessmp3");
              this.audioStop("scanFailuremp3");
            })
            .catch(() => {
              this.$message.error("扫描失败！");
              this.cb.palletNo = "";
              this.cb.barcode = "";
              this.audioPlay("scanSuccessmp3");
              this.audioStop("scanFailuremp3");
            });
        }
      },
      getKZGManageScanCDS() {
        if(this.cbs.palletNo) {
          this.$http
            .post("basic", `sAPProductionOrders/cbs/${this.cbs.palletNo}/${this.cbs.stationCode}`)
            .then(() => {
              this.$message.success("扫描成功");
              this.$refs["orders"].focus();
              this.cbs.palletNo = "";
              this.audioPlay("scanSuccessmp3");
              this.audioStop("scanFailuremp3");
            })
            .catch(() => {
              this.$message.error("扫描失败！");
              this.$refs["orders"].focus();
              this.cbs.palletNo = "";
              this.audioPlay("scanSuccessmp3");
              this.audioStop("scanFailuremp3");
            });
        }
      },
    },
  };
</script>

<style lang="scss">


</style>
